module.exports = __webpack_public_path__ + "img/icon_lbsq.2cd879cc.png";